import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from './shared/services/auth.service';
import { SharedService } from './shared/services/shared.service';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { CambiarClaveModule } from './pages/cambiar-clave/cambiar-clave.module';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { SideNavService } from './shared/services/side-nav.service';
import { NgxCaptchaModule } from 'ngx-captcha';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    CambiarClaveModule,
    MaterialModule,
    NgxSpinnerModule,
    NgxCaptchaModule
  ],
  providers: [
    AuthService,
    SharedService,
    SideNavService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
